import React from 'react';
import { Form, Field } from 'react-final-form';
import { FormGroup, Button } from 'react-bootstrap';
import { required } from '../../../forms';
import InputWithLabel from '../../../forms/InputWithLabel';

const RecoverForm = ({ onSubmit, initialValues }) => (
  <Form
    onSubmit={onSubmit}
    initialValues={initialValues}
    validate={values => {
      const errors = {};
      if (!values.email) {
        errors.email = 'Please enter your email address';
      }
      return errors;
    }}
    render={({ handleSubmit, submitting, pristine, errors }) => (
      <div>
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Field
              name="email"
              type="text"
              label="Email"
              component={InputWithLabel}
              placeholder="email"
              validate={required}
            />
          </FormGroup>
          <FormGroup>
            <Button disabled={pristine || submitting} bsStyle="default" type="submit">
              Recover Password
            </Button>
          </FormGroup>
        </form>
      </div>
    )}
  />
);

export default RecoverForm;



// WEBPACK FOOTER //
// src/routes/login/containers/RecoverForm.js